import { Link } from "react-router-dom";

export default function WhyChoose() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">
            {/* Left - Content */}
            <div className="lg:w-1/2">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">
                Why Choose Kakobuy
              </p>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
                Expert Buying Guides &amp;
                <br />
                Verified Research
              </h2>

              <div className="space-y-5">
                <div className="flex gap-4">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0 mt-0.5">
                    <i className="ri-shield-check-line text-primary-600 text-sm"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">
                      Verified Seller Research
                    </h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      Every seller in our <strong>Kakobuy Spreadsheet</strong> has been manually reviewed for
                      shipping speed, product accuracy, and customer satisfaction.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0 mt-0.5">
                    <i className="ri-image-line text-secondary-600 text-sm"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">
                      Real Product Comparisons
                    </h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      Compare products across sellers using real QC photos and buyer feedback to
                      make informed purchasing decisions every time.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0 mt-0.5">
                    <i className="ri-refresh-line text-accent-600 text-sm"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">
                      Updated Spreadsheet Data
                    </h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      Our <strong>Kakobuy Spreadsheet</strong> receives daily updates to keep listings
                      fresh, prices accurate, and seller ratings current.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0 mt-0.5">
                    <i className="ri-user-smile-line text-primary-600 text-sm"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">
                      Safe Shopping Recommendations
                    </h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      Get expert tips on staying safe while shopping, understanding QC photos,
                      and choosing the best shipping options for your location.
                    </p>
                  </div>
                </div>
              </div>

              {/* Article Link */}
              <Link
                to="/guide/how-to-use-kakobuy-spreadsheet"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md hover:bg-primary-600 transition-colors text-sm font-semibold whitespace-nowrap cursor-pointer"
              >
                Read the Complete Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            {/* Right - Image */}
            <div className="lg:w-1/2 w-full">
              <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20flat%20lay%20with%20a%20laptop%20displaying%20abstract%20colorful%20spreadsheet%20interface%20surrounded%20by%20thoughtfully%20arranged%20fashion%20and%20lifestyle%20items%20including%20a%20watch%20a%20small%20plant%20and%20a%20notebook%20on%20a%20warm%20cream%20wooden%20surface%20natural%20daylight%20from%20a%20large%20window%20soft%20shadows%20editorial%20productivity%20aesthetic%20warm%20neutral%20tones%20no%20text%20no%20people&width=900&height=675&seq=kakobuy-why-choose-v3-2026&orientation=landscape"
                  alt="Kakobuy Spreadsheet - Verified Shopping Experience"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}